module.exports = __webpack_public_path__ + "img/qrcode.11ebffe8.jpg";